import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const V1_SCHEDULE_STATUS_LABELS = {
    DRAFT: "草稿",
    SUBMITTED: "已提交",
    CONFIRMATION_PENDING: "待确认",
    AIRLINE_CONFIRMED: "航司确认",
    PUBLISHED: "已发布",
    DEPRECATED: "已废弃",
};

function formatDateOnly(value) {
    if (!value) {
        return "";
    }
    const date = dayjs.utc(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : "";
}

function formatDateTime(value) {
    if (!value) {
        return "更新时间未知";
    }
    const date = dayjs.utc(value);
    return date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "更新时间未知";
}

function formatTagItem(tag) {
    if (tag == null) {
        return "";
    }
    if (typeof tag === "object") {
        return String(tag.label || tag.name || tag.value || "").trim();
    }
    return String(tag).trim();
}

function formatTags(tags) {
    if (Array.isArray(tags)) {
        return tags.map(formatTagItem).filter(Boolean).join("、");
    }
    return formatTagItem(tags);
}

function formatAircraft(schedule = {}) {
    let aircraftRegs = [];
    if (Array.isArray(schedule.aircraft_regs)) {
        aircraftRegs = schedule.aircraft_regs;
    } else if (Array.isArray(schedule.aircraftRegs)) {
        aircraftRegs = schedule.aircraftRegs;
    }
    const aircraftLabel = aircraftRegs.map((reg) => String(reg).trim()).filter(Boolean).join("、");
    return aircraftLabel || String(schedule.aircraft_reg || "未记录飞机").trim();
}

export function buildV1ScheduleDisplayFields(schedule = {}) {
    const startDate = formatDateOnly(schedule.start_date);
    const endDate = formatDateOnly(schedule.end_date);
    const dateRange = startDate || endDate ? `${startDate || "未设开始"} 至 ${endDate || "未设结束"}` : "未设日期范围";

    const status = String(schedule.status || "").trim();

    return {
        name: String(schedule.name || "未命名旧版计划").trim(),
        tags: formatTags(schedule.tags),
        description: String(schedule.description || "").trim(),
        aircraft: formatAircraft(schedule),
        dateRange,
        status: status ? V1_SCHEDULE_STATUS_LABELS[status] || status : "未记录状态",
        flightCount: schedule.flight_count == null ? "航班数未知" : `${schedule.flight_count} 航班`,
        updatedAt: formatDateTime(schedule.updated_at),
    };
}

export function buildV1ScheduleOptionLabel(schedule = {}) {
    const fields = buildV1ScheduleDisplayFields(schedule);
    return [
        fields.name,
        fields.tags ? `标记 ${fields.tags}` : null,
        `飞机 ${fields.aircraft}`,
        fields.dateRange,
        `状态 ${fields.status}`,
        fields.flightCount,
        `更新 ${fields.updatedAt}`,
    ].filter(Boolean).join(" · ");
}

export function buildV1ScheduleOptions(schedules = []) {
    return schedules
        .map((schedule) => {
            if (schedule?.id == null) {
                return null;
            }
            const fields = buildV1ScheduleDisplayFields(schedule);
            const label = buildV1ScheduleOptionLabel(schedule);
            return {
                label,
                value: String(schedule.id),
                title: fields.description || label,
                searchText: [label, fields.description].filter(Boolean).join(" "),
            };
        })
        .filter(Boolean);
}
